import React from "react";
import { NameAndHub } from "../NameAndHub";
import { Row, Col } from "antd";

export function ViewBankDetails({ bankDetails }) {
  return (
    <>
      {" "}
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">Firm Bank Details</div>
        </div>
        {/* <div className="view-basic-details-contain">
        
        </div> */}
        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Account holder’s name"}
                  hub={bankDetails?.accountHolderName}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"Bank name"} hub={bankDetails?.bankName} />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"Account no"} hub={bankDetails?.accountNo} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"IFSC code"} hub={bankDetails?.ifsc} />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
}
